import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default from 'react';
import { useResizeDetector } from 'react-resize-detector';

var useTrackTableScroll = function useTrackTableScroll(targetRef) {
  var _React$useState = React__default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    scrolling = _React$useState2[0],
    setScrolling = _React$useState2[1];
  var _React$useState3 = React__default.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    scrollEndTop = _React$useState4[0],
    setScrollEndTop = _React$useState4[1];
  var _React$useState5 = React__default.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    scrollEndLeft = _React$useState6[0],
    setScrollEndLeft = _React$useState6[1];
  var _React$useState7 = React__default.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    scrollEndBottom = _React$useState8[0],
    setScrollEndBottom = _React$useState8[1];
  var onResize = React__default.useCallback(/* istanbul ignore next - react-resize-detector does not have API to trigger these in tests, also this has only visual effects that should be tested manually */
  function () {
    var current = targetRef.current;
    if (!current) {
      return;
    }
    setScrolling(current.scrollHeight > current.clientHeight || current.scrollWidth > current.clientWidth);
  }, [targetRef, setScrolling]);
  useResizeDetector({
    onResize: onResize,
    targetRef: targetRef,
    // Workaround for "hidden exception" emitted to the window object
    // see issue for context
    // https://github.com/maslianok/react-resize-detector/issues/45
    refreshMode: 'debounce',
    refreshRate: 0
  });
  var handleScrolling = React__default.useCallback(/* istanbul ignore next - react-resize-detector does not have API to trigger these in tests, also this has only visual effects that should be tested manually */
  function (_e) {
    if (!targetRef.current) {
      return;
    }
    if (targetRef.current.scrollTop === 0) {
      setScrollEndTop(true);
    } else {
      setScrollEndTop(false);
    }
    if (targetRef.current.clientHeight + targetRef.current.scrollTop === targetRef.current.scrollHeight) {
      setScrollEndBottom(true);
    } else {
      setScrollEndBottom(false);
    }
    if (targetRef.current.scrollLeft === 0) {
      setScrollEndLeft(true);
    } else {
      setScrollEndLeft(false);
    }
  }, [setScrollEndTop, setScrollEndBottom, setScrollEndLeft, targetRef]);
  return {
    scrolling: scrolling,
    scrollEndTop: scrollEndTop,
    scrollEndBottom: scrollEndBottom,
    scrollEndLeft: scrollEndLeft,
    handleScrolling: handleScrolling
  };
};

export { useTrackTableScroll };
